// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/NewTask/Content/Stage/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_CreateProcedureReceivables_NewTask_Content_Stage($board_id: uuid!) {
  tasks_stages(
    where: { board_id: { _eq: $board_id } }
    order_by: { order: asc }
  ) {
    id
    text: name
    order
    done
  }
}

`